/**
 * The two-button Y/N toggle.
 *
 * `undefined` is a real state and is rendered as neither button pressed —
 * "not yet told" is not the same as "told no" (see the gate rule in
 * src/core/calc.ts conditionHolds), and a Y/N that defaults to No would open
 * and close branches the surveyor never answered.
 */

import type { ReactNode } from 'react';

export interface YesNoProps {
  value: boolean | undefined;
  onChange: (next: boolean) => void;
  /** Accessible name for the pair — usually the question label. */
  ariaLabel: string;
  yesLabel?: string;
  noLabel?: string;
  disabled?: boolean;
}

export function YesNo({
  value,
  onChange,
  ariaLabel,
  yesLabel = 'Yes',
  noLabel = 'No',
  disabled = false,
}: YesNoProps): ReactNode {
  return (
    <div className="ynrow" role="group" aria-label={ariaLabel}>
      <button
        type="button"
        className="yn"
        aria-pressed={value === true}
        disabled={disabled}
        onClick={() => onChange(true)}
      >
        {yesLabel}
      </button>
      <button
        type="button"
        className="yn"
        aria-pressed={value === false}
        disabled={disabled}
        onClick={() => onChange(false)}
      >
        {noLabel}
      </button>
    </div>
  );
}
